colors = [
	value: 'orange'
	label: 'Orange'
	direction: '90deg'
	color: '#FFB252'
	gradient: ['#FFA751', '#ffcf34']
,
	value: 'green'
	label: 'Green'
	direction: '90deg'
	color: '#3cf2ad'
	gradient: ['#43e97b', '#38f9d7']
,
	value: 'purple'
	label: 'Purple'
	direction: '-148deg'
	color: '#7c50d3'
	gradient: ['#5f72bd', '#9b23ea']
,
	value: 'red'
	label: 'Red'
	direction: '90deg'
	color: '#d12432'
	gradient: ['#93291E', '#ED213A']
,
	value: 'pink'
	label: 'Pink'
	direction: '90deg'
	color: '#fc5d84'
	gradient: ['#ff758c', '#ff7eb3']
,
	value: 'blue'
	label: 'Blue'
	direction: '90deg'
	color: '#0082f1'
	gradient: ['#005bea', '#00c6fb']
,
	value: 'darkblue'
	label: 'Dark Blue'
	direction: '90deg'
	color: '#053ea4'
	gradient: ['#021B79', '#0575E6']
,
	value: 'black'
	label: 'Black'
	direction: '285deg'
	color: '#282a2b'
	gradient: ['#232526', '#414345']
,
	value: 'silver'
	label: 'Silver'
	direction: '155deg'
	color: '#596775'
	gradient: ['#bdc3c7', '#2c3e50']
]

hiddenColors = [
	value: 'hotpink'
	label: 'Hot Pink'
	direction: '155deg'
	color: '#ff199f'
	gradient: ['#ff199f', '#ff0094']
,
	value: 'flatblack'
	label: 'Flat Black'
	direction: '155deg'
	color: '#000000'
	gradient: ['#000000', '#000000']
]

colors.all = [colors..., hiddenColors...]
colors.hidden = hiddenColors

export default colors